var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.chartLoading),expression:"chartLoading"}],staticClass:"w-full h-100px",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }